/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import PercentageBar from 'components/shared/percentagebar/percentagebar';
// STYLES
// (css-in-js, imported as JS from external file, turned into CSS via library used in utils)
import styles from 'components/content/shared/questionset/emoji/answer/answer_styles';
import { createStyles } from 'utils/styles';
const sheet = createStyles(styles, {link:false});



/* ========== ~~~~~~~~~~ EMOJI ANSWER ~~~~~~~~~~ ========== */
// STATELESS FUNCTIONAL COMPONENT
// used to create markup structure and render UI
// doesn't need all the lifecycle functions attached
const EmojiAnswer = (props) => {
    return(
        <span className={`${sheet.classes.uniqueanswer} uniqueanswer`}>
            <span className={`${sheet.classes.graphic} graphic`}><span class={`${sheet.classes.emoji} emoji`}>{`${props.emoji}`}</span></span>
            { props.isResult ? <PercentageBar type={`vertical1`} barCoefficient={props.barCoefficient} amount={`${props.predictionPercentage}`} isClicked={props.isClicked} isCorrectAnswer={props.isCorrectAnswer} /> : null }
        </span>
    );
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default EmojiAnswer;
